import { Client } from "@/shared/model/client.model";
import FranchisedVM from "@/shared/model/global/franchise/franchised-vm.model";
import { Company } from "@/shared/model/user-management/company.model";
import { User } from "@/shared/model/user-management/user.model";
import axios from "axios";

const baseApiUrl = "api/company";

export default class FranchiseService{

  public askAddUserBelowFranchisor(client : Client, company : Company): Promise<boolean> {
    let franchisedVm : FranchisedVM = new FranchisedVM(company.name, client.gender, client.firstName, client.lastName, client.mail);
    return new Promise<boolean>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/ask-add-user-below-franchisor",franchisedVm)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }


  
    
  public getAllFranchisedFromOneFranchisor(): Promise<FranchisedVM[]> {
      return new Promise<FranchisedVM[]>(function (resolve, reject) {
        axios
          .get(baseApiUrl + "/franchiseds")
          .then(function (res) {
            resolve(res.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
  }

  public createFranchised(client : Client, company : Company): Promise<FranchisedVM> {
    let franchisedVm : FranchisedVM = new FranchisedVM(company.name, client.gender, client.firstName, client.lastName, client.mail);
    return new Promise<FranchisedVM>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/create/franchised",franchisedVm)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}